import React from 'react';
import logo from '../../icons/miistin_logo_miistin.svg';
import styles from './ImageArea.module.scss';

export const ImageArea: React.FC = () => {
  return (
    <div className={styles.img_area}>
      <div className={styles.logo}>
        <img src={logo} />
      </div>
      <div className={styles.subtitle}>ゲーム開発・Webシステム開発の会社</div>
    </div>
  );
};
